import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, Table, TableBody, TableHeader, TableItem, TableRow} from 'spectacle';
import {Slide} from '../components/slide';
import {Month} from '../support/import_csv';
import {formatEuro} from '../../support/format_money';
import {toYears} from '../support/years';

interface OwnProps {
    referenceDate: Date;
    months: Month[];
}

export const Totals: FunctionComponent<OwnProps> = ({months, referenceDate}) => {
    const years = toYears(months, referenceDate);
    return (
        <Slide>
            <Heading size={1} textAlign="left" textColor="secondary">
                Totals
            </Heading>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableItem />
                        {years.map((year) => {
                            return (
                                <TableItem textColor={year.year === referenceDate.getFullYear() ? '' : 'tertiary'}>
                                    {year.year}
                                </TableItem>
                            );
                        })}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableItem>Revenue</TableItem>
                        {years.map((year) => {
                            return (
                                <TableItem textColor={year.year === referenceDate.getFullYear() ? '' : 'tertiary'}>
                                    {formatEuro(year.revenue)}
                                </TableItem>
                            );
                        })}
                    </TableRow>
                    <TableRow>
                        <TableItem>Costs</TableItem>
                        {years.map((year) => {
                            return (
                                <TableItem textColor={year.year === referenceDate.getFullYear() ? '' : 'tertiary'}>
                                    {formatEuro(year.cost)}
                                </TableItem>
                            );
                        })}
                    </TableRow>
                    <TableRow>
                        <TableItem>Result</TableItem>
                        {years.map((year) => {
                            return (
                                <TableItem textColor={year.year === referenceDate.getFullYear() ? '' : 'tertiary'}>
                                    {formatEuro(year.result)}
                                </TableItem>
                            );
                        })}
                    </TableRow>
                </TableBody>
            </Table>
        </Slide>
    );
};
